import RegisterForm from "../../components/RMTable/AddRM";
import { Box } from "@mui/material";
import { OFF_WHITE } from "../../constants/layout";

const AddUser = () => {
  return (
    <Box
      sx={{
        minHeight: "100%",
        bgcolor: OFF_WHITE,
        px: { xs: 3, sm: 5, md: 6, lg: 8 },
        py: { xs: 3, md: 4 },
      }}
    >
      <Box sx={{ maxWidth: 900, mx: "auto" }}>
        <RegisterForm variant="page" />
      </Box>
    </Box>
  );
};

export default AddUser;
